export default __webpack_public_path__ + "static/media/arangement-opposite.c24d0046.PNG";